export default "__VITE_ASSET__CRdayzLp__"